import React, { Component } from 'react';
import {StripeProvider, Elements} from 'react-stripe-elements';
import './Checkout.css';

import cookie from 'react-cookies';
import { API_BASE, stripe_publishable_key } from '../config';

import scrollToComponent from 'react-scroll-to-component';

import Button from './Button';
import Input from '../components/Input';
import InputAddress from '../components/Input-Address';
import InputCreditCard from '../components/Input-CreditCard-StripeElements';
import Notification from '../components/Notification';

import RSS_checkout from '../images/ReallySimpleCheckout-02.svg';
import checkmark from '../images/baseline-done-24px.svg';
//import PoweredByStripe from '../images/powered_by_stripe.svg';

import AmEx from '../images/credit_cards/amex.svg';
import Diners from '../images/credit_cards/diners.svg';
import Discover from '../images/credit_cards/discover.svg';
import JCB from '../images/credit_cards/jcb.svg';
import Mastercard from '../images/credit_cards/mastercard.svg';
import Visa from '../images/credit_cards/visa.svg';

class Checkout extends Component {

  constructor(props) {
    super(props);

    this._createOrder = this._createOrder.bind(this);
    this._toggleFixed = this._toggleFixed.bind(this);
    this._editShipping = this._editShipping.bind(this);
    this._editBilling = this._editBilling.bind(this);
    this._editEmail = this._editEmail.bind(this);
    this._updateCard = this._updateCard.bind(this);
    this._updateForm = this._updateForm.bind(this);
    this._updateStep = this._updateStep.bind(this);

    this.state = {
      cart:this.props.cart,
      fixed:true,
      form:JSON.parse(localStorage.getItem('checkout_form')) || {
        name:"",
        address:"",
        card_name:"",
        card_lastfour:"",
        card_token:"",
        email:""
      },
      notification_text:"",
      shipping:this.props.shipping,
      store:this.props.store,
      store_permalink:this.props.store_permalink,
      
      shipping_complete:false,
      billing_complete:false,
      email_complete:false,

      shipping_message:"",
      billing_message:"",
      email_message:""
    };

  }

  componentWillReceiveProps(newProps) {

    this.setState({
      cart:newProps.cart,
      shipping:newProps.shipping,
      store:newProps.store
    });

  }

  render() {
    
    return (
      <div>
        <div ref="Checkout" className={this.state.fixed ? "Page Checkout fixed" : "Page Checkout"} onClick={this.state.fixed ? this._toggleFixed : null}>          
          <div className="clearflex align-center">
            <div>
              <p style={{marginTop:"1.5em"}}><img src={RSS_checkout} alt="Checkout" style={{minWidth:"250px"}} /></p>
            </div>
            
            <div>
              <h2>Checkout for ${this.state.cart && this.state.cart.totals ? this.state.cart.totals.total : "0"} ▾</h2>
            </div>

            <p className="clearflex align-center justify-center">
              <img src={Visa} alt="Visa" className="creditCardIcon" />
              <img src={Mastercard} alt="Mastercard" className="creditCardIcon" />
              <img src={AmEx} alt="American Express" className="creditCardIcon" />
              <img src={Discover} alt="Discover" className="creditCardIcon" />
              <img src={Diners} alt="Diners Club" className="creditCardIcon" />
              <img src={JCB} alt="JCB" className="creditCardIcon" />
            </p>
          </div>

          <Notification text={this.state.notification_text} timeout="10000" overlay={true} />
          
              <div className="hiddenWhenFixed">
                <hr />
                <div className="clearflex align-flex-start checkoutFields">
                  <div className="half column">
                    <h3 style={{display:"none"}} onClick={this._editShipping}>{this.state.shipping ? "Shipping" : "Name" }</h3>
                    <div className="Checkout--FieldGroup">
                      <Input ref="nameinput" label="Name" name="name" value={this.state.form.name} onChange={this._updateForm} onBlur={this._updateStep} onFocus={this._editShipping} noSave />
                      {this.state.shipping ? <InputAddress label="Shipping Address" name="address" value={this.state.form.address} onChange={this._updateForm} onBlur={this._updateStep} onFocus={this._editShipping} noSave /> : null }
                    </div>
                  </div>
                  <div className="half column">
                    <div className="Checkout--Message Checkout--Message-Shipping">
                      <div onClick={this._editShipping}>{this.state.shipping_message}</div>
                    </div>
                  </div>
                  {this.state.shipping ? <p>&nbsp;</p> : null }
                </div>

                <div className="clearflex align-flex-start checkoutFields">
                  <div className="half column">
                    <h3 style={{display:"none"}} onClick={this._editBilling}>Billing</h3>
                    <div className={this.state.shipping_complete ? "Checkout--FieldGroup" : "Checkout--FieldGroup hidden-off" }>
                      {this.state.showCardName ? <Input label="Name on Card" name="card_name" value={this.state.form.card_name} onChange={this._updateForm} onBlur={this._updateStep} onFocus={this._editBilling} noSave /> : null }
                      
                      <div>
                        <StripeProvider apiKey={stripe_publishable_key}>
                          <Elements>  
                            <InputCreditCard onBlur={this._updateCard} onFocus={this._editBilling} card_lastfour={this.state.form.card_lastfour} card_token={this.state.form.card_token} />
                          </Elements>
                        </StripeProvider>
                      </div>

                      <div>
                        
                      </div>


                    </div>
                  </div>
                  <div className="half column">
                    <div className="Checkout--Message">
                      <div onClick={this._editBilling}>{this.state.billing_message}</div>
                    </div>
                  </div>
                  {this.state.shipping ? <p>&nbsp;</p> : null }
                </div>

                <div className="clearflex align-flex-start checkoutFields">
                  <div className="half column">
                    <h3 style={{display:"none"}} onClick={this._editEmail}>Email for receipt</h3>
                    <div className={this.state.shipping_complete && this.state.billing_complete ? "Checkout--FieldGroup" : "Checkout--FieldGroup hidden-off"}>
                      <Input label="Email for receipt" type="email" name="email" value={this.state.form.email} onChange={this._updateForm} onBlur={this._updateStep} onFocus={this._editEmail} noSave />
                    </div>
                  </div>
                  <div className="half column">
                    <div className="Checkout--Message">
                      <div onClick={this._editEmail}>{this.state.email_message}</div>
                    </div>
                  </div>
                </div>

                <div className="checkoutFields">
                  <Button style={{fontSize:"1.25em"}} label="&nbsp;" text={this.state.cart && this.state.cart.cart.length > 0 ? "Complete Purchase for $"+(this.state.cart && this.state.cart.totals ? this.state.cart.totals.total : "0") : "There's nothing in your cart." } onClick={this._createOrder} disabled={this.state.cart && this.state.cart.cart.length > 0 && this.state.shipping_complete && this.state.billing_complete && this.state.email_complete ? false : true } />
                  <p style={{fontSize:".9em",marginTop:"0"}}>
                    <br />
                    <strong>Total ${this.state.cart && this.state.cart.totals ? this.state.cart.totals.total : "0"}</strong><br />
                    Subtotal ${this.state.cart && this.state.cart.totals ? this.state.cart.totals.cart_total : "0"}<br />
                    Discounts ${this.state.cart && this.state.cart.totals ? this.state.cart.totals.discounts_total : "0"}<br />
                    Shipping ${this.state.cart && this.state.cart.totals ? this.state.cart.totals.shipping_total : "0"}
                  </p>
                </div>

              </div>
          

        </div>

        <p style={{fontSize:".75em",padding:"4em",textAlign:"center"}}>&copy; 2018 Really Simple Store {this.state.store ? "and "+this.state.store.name : null }</p>

      </div>
    );
  
  }

  _createOrder() {

    var _this = this;

    var formData = new FormData();
    formData.append('store_id',this.state.store.id);
    formData.append('store',JSON.stringify(this.state.store));
    formData.append('user',JSON.stringify(this.state.form));
    formData.append('cart_token',cookie.load(_this.state.store_permalink));

    var request = new Request(`${API_BASE}orders`, {
      method: 'POST', 
      mode: 'cors',
      body: formData
    });

    _this.setState({
      notification_text:"Order submitted..."
    });
    fetch(request).then(function(response) {
      return response.json();
    }).then(function(json) {
      //console.log('parsed json', json);
      
      if (json.success) {
        _this.setState({
          notification_text:json.success+" An email receipt was sent to "+_this.state.form.email,
          fixed:true
        });

        // remove cookie
        _this.props.emptyCart();

        // remove credit card token
        _this._updateForm("card_token","");
        _this._updateForm("card_lastfour","");

      }

    }).catch(function(ex) {
      console.log('parsing failed', ex);
    });
    


  }

  _toggleFixed() {
    this.setState({
      fixed:!this.state.fixed
    },function() {
      if (!this.state.fixed) {
        scrollToComponent(this.refs.Checkout, { offset: 0, align: 'top', duration: 500});
        this._updateStep();
        //this.refs.nameinput.focus();
      }
    }.bind(this));
  }

  _editShipping() {
    this.setState({
      shipping_complete:false,
      billing_complete:true,
      email_complete:true,
     //shipping_message:""
    });
  }
  _editBilling() {
    this.setState({
      shipping_complete:true,
      billing_complete:false,
      email_complete:true,
      //billing_message:""
    });
  }
  _editEmail() {
    this.setState({
      shipping_complete:true,
      billing_complete:true,
      email_complete:false,
      //email_message:""
    });
  }

  _updateForm(name,value) {

    var form = this.state.form;

    form[name] = value;

    this.setState({
      form:form
    },function() {
      localStorage.setItem('checkout_form',JSON.stringify(this.state.form));
    });

  }

  _updateCard(token,lastfour) {

    var form = this.state.form;

    form['card_token'] = token;
    form['card_lastfour'] = lastfour;

    this.setState({
      form:form
    },function() {
      localStorage.setItem('checkout_form',JSON.stringify(this.state.form));
      this._updateStep();
    });

  }

  _updateStep() {

    var shipping_complete = false;
    var billing_complete = false;
    var email_complete = false;
    
    if (this.state.form.email.length) {
      email_complete = true;
    }
    if (this.state.form.card_lastfour.length) { //this.state.form.card_name.length && 
      billing_complete = true;
    }
    if (this.state.form.name.length && (!this.state.shipping || this.state.form.address.length)) {
      shipping_complete = true;
    }

    var shipping_message = "";
    var billing_message = "";
    var email_message = "";

    // shipping status message
    if (!this.state.form.name && !this.state.form.address) {
      shipping_message = <p></p>; //<p>{this.state.shipping ? "Who are you shipping this to?" : "Your name" }</p>;
    } else {
      if (!this.state.form.name) {
        shipping_message = <p></p>; //<p>{this.state.shipping ? "Remember to add the recipient's name" : "Remember to add your name" }</p>;
      } else {
        if (this.state.shipping && !this.state.form.address) {
          shipping_message = <p className="Checkout--Message-Shipping">Start typing an address for suggestions...</p>;
        } else {
          shipping_message = <p><img src={checkmark} alt="Checkmark" style={{verticalAlign:"middle"}} /></p>; // {this.state.form.address} <a onClick={this._editShipping}>Edit</a>
        }
      }
    }

    // billing status message
    if (!this.state.form.name || !this.state.form.address) { // at least one shipping is emtpy
        billing_message = <p>🔒 Your info is encrypted and transmitted securely. We don't save or store your card numbers.</p>;
    } else if (!this.state.form.card_lastfour) { // shipping done but card info open // !this.state.form.card_name && 
        billing_message = <p>🔒 Your info is encrypted and transmitted securely. <br />We don't save or store your card numbers.</p>;
    }
    if (this.state.form.card_lastfour) {
      billing_message = <p><img src={checkmark} alt="Checkmark" style={{verticalAlign:"middle"}} /></p>;
    }


    // email status message
    if (!this.state.form.name || !this.state.form.address || !this.state.form.card_lastfour) { // !this.state.form.card_name || 
        email_message = <p></p>;
    } else if (!this.state.form.email) {
        email_message = <p></p>;
    }
    if (this.state.form.email) {
        email_message = <p><img src={checkmark} alt="Checkmark" style={{verticalAlign:"middle"}} /></p>; // {this.state.form.email}  <a onClick={this._editEmail}>Edit</a>
    }          




    this.setState({
      email_complete:email_complete,
      billing_complete:billing_complete,
      shipping_complete:shipping_complete,

      shipping_message:shipping_message,
      billing_message:billing_message,
      email_message:email_message
    });


  }

}

export default Checkout;


// WEBPACK FOOTER //
// ./src/components/Checkout.js